import HttpResponse from "../../../../../utils/http/http.response";

export enum ContractsTaxiForwardingContractDetailsResponseItemModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export type ContractsTaxiForwardingContractDetailsResponseItemTaxiCorporation =
  {
    companyName: string;
  };

export type ContractsTaxiForwardingContractDetailsResponseItem = {
  validSince: Date;
  validTo: Date;
  disabled: boolean;
  model: ContractsTaxiForwardingContractDetailsResponseItemModel;
  distanceRate: number;
  haltingTimeRate: number;
  haltingTimeAfterMinutes: number;
  producerTaxi: ContractsTaxiForwardingContractDetailsResponseItemTaxiCorporation;
  consumerTaxi: ContractsTaxiForwardingContractDetailsResponseItemTaxiCorporation;
  displayName: string;
  priority: number;
};

type ContractsTaxiForwardingContractDetailsResponse =
  HttpResponse<ContractsTaxiForwardingContractDetailsResponseItem>;

export default ContractsTaxiForwardingContractDetailsResponse;
